/* eslint-disable indent */
import React, { createRef } from 'react'
import { useDispatch } from 'react-redux'
import PropTypes from 'prop-types'
import { useTranslation } from 'react-i18next'
import { useSnackbar } from 'notistack'
import { Dialog, DialogContent, Tooltip } from '@mui/material'
import { createStyles, makeStyles } from '@mui/styles'
import CloseIcon from '@mui/icons-material/Close'
import moment from 'moment'

import {
  // getFlowTaskInteractionResources,
  createFlowTaskInteractionResource,
  createFlowTaskInteractionVariable,
  // getFlowTaskInteractionVariables,
  cacheCreateFlowTaskInteractionResource,
  cacheCreateFlowTaskInteractionVariable
} from '../../../../../../actions'
import { attributesNames, dialogSize, interactionModes, interactionOperations } from '../../../../../../constants'
import { checkErrorResponse, clearData, DebugView, isDebug, Logger, LoggerTypes } from '../../../../../../utils'
import { Button, buttonModes, buttonTypes, DataGrid, FormTitle, iconNames } from '../../../../../../components'
import '../../../common-elements-style.scss'
import './style.scss'

const useStyles = makeStyles((theme) =>
  createStyles({
    closeStyle: {
      border: `1px solid ${theme.palette.primary.main}`
    },
    closeIconStyle: {
      color: theme.palette.primary.main
    }
  })
)

/**
 * Display the Interaction dialog to import in tasks either a `variable` or a `resource`
 *
 * @param {object} currentProject,
 * @param {object} currentScenario,
 * @param {object} currentFlowGroup,
 * @param {object} currentTaskInstance,
 * @param {boolean} openDialog,
 * @param {func} setOpenDialog,
 * @param {Array<object>} variables,
 * @param {Array<object>} variablesSelected, Ex: [{ id: 'UUID', operation: 'MINUS', value: 1, type: 'ON_START' }, {...}, ...]
 * @param {Array<object>} resources,
 * @param {Array<object>} resourcesSelected, Ex: [{ id: 'UUID', operation: 'PLUS', quantity: 1 }, {...}, ...]
 * @param {string} mode Can be either 'interactionModes.START' or 'interactionModes.FINISH'
 * @param {string} type Can be either 'attributesNames.VARIABLES' or 'attributesNames.RESOURCES'
 * @returns {Dialog}
 */
export const FlowElementTaskInteractionDialog = ({
  currentProject,
  currentScenario,
  currentFlowGroup,
  currentTaskInstance,
  variables,
  resources,
  openDialog,
  setOpenDialog,
  mode, // <-- Can be either `interactionModes.START` or `interactionModes.FINISH`
  type // <-- Can be either `attributesNames.VARIABLES`or `attributesNames.RESOURCES`
  // refreshAfterSaving
}) => {
  const { t } = useTranslation()
  const dispatch = useDispatch()
  const { enqueueSnackbar } = useSnackbar()
  const styleClasses = useStyles()
  const ref = createRef()

  const pid = currentProject?.id || null
  const sid = currentScenario?.id || null
  const fid = currentFlowGroup?.id || null
  const tid = currentTaskInstance?.id || null

  const onDialogClose = () => {
    Logger.trace(LoggerTypes.CONTROLLER, 'FlowElementTaskInteractionDialog.onDialogClose()')
    setOpenDialog(false)
    // refreshAfterSaving()
  }

  // const [resourcesSelected, setResourcesSelected] = useState([])
  // const [variablesSelected, setVariablesSelected] = useState([])
  const resourcesSelected = (currentTaskInstance?.resource_interactions || []).map((el) => el?.resource?.id || null)
  const variablesSelected = (currentTaskInstance?.variable_interactions || [])
    .filter((el) => el?.type === mode)
    .map((el) => el?.variable?.id || null)

  // const loadSelectedResources = () => {
  //   dispatch(getFlowTaskInteractionResources(pid, sid, fid, tid))
  //     .then((res) => {
  //       Logger.trace(
  //         LoggerTypes.CONTROLLER,
  //         'FlowElementTaskInteractionDialog.loadSelectedResources().dispatch(getFlowTaskInteractionResources(...)).then()',
  //         { res }
  //       )
  //       setResourcesSelected((res?.data || []).map((el) => el?.resource?.id || null))
  //     })
  //     .catch((err) => {
  //       Logger.trace(
  //         LoggerTypes.WARN,
  //         'FlowElementTaskInteractionDialog.loadSelectedResources().dispatch(getFlowTaskInteractionResources(...)).catch()',
  //         {
  //           err
  //         }
  //       )
  //       checkErrorResponse(err, enqueueSnackbar, t)
  //     })
  // const selectedResources = (currentTaskInstance.resource_interactions || []).map((el) => el?.resource?.id || null)
  // Logger.trace(LoggerTypes.CONTROLLER, 'FlowElementTaskInteractionDialog.loadSelectedResources()', {
  //   selectedResources
  // })
  // setResourcesSelected(selectedResources)
  // }

  // const loadSelectedVariables = () => {
  //   dispatch(getFlowTaskInteractionVariables(pid, sid, fid, tid))
  //     .then((res) => {
  //       const _selected = clearData(res?.data || [])
  //         .filter((el) => el.type === mode)
  //         .map((el) => el?.variable?.id || null)
  //       const _variablesSelected = [...new Set(_selected)]

  //       Logger.trace(
  //         LoggerTypes.CONTROLLER,
  //         'FlowElementTaskInteractionDialog.loadSelectedVariables().dispatch(getFlowTaskInteractionVariables(...)).then()',
  //         { res, _variablesSelected }
  //       )

  //       setVariablesSelected(_variablesSelected)
  //     })
  //     .catch((err) => {
  //       Logger.trace(
  //         LoggerTypes.WARN,
  //         'FlowElementTaskInteractionDialog.loadSelectedVariables().dispatch(getFlowTaskInteractionVariables(...)).catch()',
  //         {
  //           err
  //         }
  //       )
  //       checkErrorResponse(err, enqueueSnackbar, t)
  //     })
  //   const selectedVariables = (currentTaskInstance.variable_interactions || [])
  //     .filter((el) => el.type === mode)
  //     .map((el) => el?.variable?.id || null)
  //   Logger.trace(LoggerTypes.CONTROLLER, 'FlowElementTaskInteractionDialog.loadSelectedVariables()', {
  //     selectedVariables
  //   })
  //   setVariablesSelected(selectedVariables)
  // }

  // const loadData = () => {
  //   if (type === attributesNames.RESOURCES) {
  //     loadSelectedResources()
  //   } else {
  //     loadSelectedVariables()
  //   }
  // }

  /**
   * Save the interaction array of object for 'variables' or 'resources'
   * Ex: [{variable_id: 'xx-UUID-xx', value: 2, operator: 'PLUS', type: 'ON_START' }]
   * Ex: [{resource_id: 'xx-UUID-xx', quantity: 25, operator: 'MINUS' }]
   *
   * @param {Array<Object>} interaction Interaction to save
   * @returns {void}
   */
  const onAddInteraction = (interaction) => {
    Logger.trace(LoggerTypes.CONTROLLER, 'FlowElementTaskInteractionDialog.onAddInteraction()', {
      type,
      mode,
      interaction
    })

    dispatch(
      type === attributesNames.RESOURCES
        ? createFlowTaskInteractionResource(pid, sid, fid, tid, interaction)
        : createFlowTaskInteractionVariable(pid, sid, fid, tid, interaction)
    )
      .then((res) => {
        Logger.trace(
          LoggerTypes.CONTROLLER,
          'FlowElementTaskInteractionDialog.onAddInteraction().dispatch(createFlowTaskInteraction(...)).then()',
          { res, type }
        )

        /**
         * Reloading the FlowGroups data after saving shouldn't be necessary.
         * @date 2022-05-17
         */
        // if (refreshAfterSaving && typeof refreshAfterSaving === 'function') {
        //   refreshAfterSaving()
        // }

        dispatch(
          type === attributesNames.RESOURCES
            ? cacheCreateFlowTaskInteractionResource(currentFlowGroup, tid, res.data)
            : cacheCreateFlowTaskInteractionVariable(currentFlowGroup, tid, res.data)
        )
        // loadData()
      })
      .catch((err) => {
        Logger.trace(LoggerTypes.WARN, 'FlowElementTaskInteractionDialog.onAddInteraction().dispatch(...).catch()', {
          err
        })
        checkErrorResponse(err, enqueueSnackbar, t)
      })
  }

  // -- resources
  const onSelectResource = (ids) => {
    const interactionResources = (ids || []).map((id) => {
      const _resourceInteraction =
        currentTaskInstance?.resource_interactions.filter((el) => el.resource_id === id)[0] || null
      return _resourceInteraction
        ? _resourceInteraction
        : {
            resource_id: id,
            operation: interactionOperations.PLUS,
            quantity: 1
          }
    })

    Logger.trace(LoggerTypes.CONTROLLER, 'FlowElementTaskInteractionDialog.onSelectResource()', {
      interactionResources,
      ids
    })

    onAddInteraction(interactionResources)
  }
  const columnsResources = [
    {
      field: 'id',
      headerName: 'ID',
      renderCell: (e) => <DebugView type={attributesNames.RESOURCES}>{e.row}</DebugView>,
      width: 220
    },
    {
      field: 'name',
      headerName: t('attributes.resources.columns.name'),
      flex: 1,
      minWidth: 250
    },
    {
      field: 'description',
      headerName: t('attributes.resources.columns.description'),
      flex: 1,
      minWidth: 250
    },
    {
      field: 'quantity',
      headerName: t('attributes.resources.columns.quantity'),
      width: 100
    },
    {
      field: 'worktime_start',
      headerName: t('attributes.resources.columns.worktime_start'),
      width: 90,
      renderCell: (e) => <span>{moment(`2022-12-25T${e.row.worktime_start}`).format('HH:mm')}</span>
    },
    {
      field: 'worktime_end',
      headerName: t('attributes.resources.columns.worktime_end'),
      width: 90,
      renderCell: (e) => <span>{moment(`2022-12-25T${e.row.worktime_end}`).format('HH:mm')}</span>
    },
    {
      field: 'non_working_days',
      headerName: t('attributes.resources.columns.non_working_days'),
      width: 150,
      renderCell: (e) => {
        const _non_working_days = String(e?.row?.non_working_days || '').split(',')
        return _non_working_days.map(
          (day, ind) =>
            day &&
            day.length && (
              <Tooltip key={`day-${ind}`} ref={ref} title={t(`common.weekdays.${day}`)}>
                <div className="non_working_days">{day.substring(0, 2)}</div>
              </Tooltip>
            )
        )
      }
    },
    {
      field: 'non_working_period',
      headerName: t('attributes.resources.columns.non_working_period'),
      width: 150
    }
  ]
  /**
   * DEPRECATED: we don't use anymore the data that come from the flow tree
   * convert: currentTaskInstance.resource_interactions_start = [{ id: 'xxx-UUID-xxx', operation: 'PLUS', quantity: 1 }, ...]
   * into: resourcesSelected = ['xxx-UUID-xxx', ...]
   */
  // const resourcesSelected = (currentTaskInstance?.resource_interactions || []).map((el) => el.resource_id) || null

  // -- variables (start/end)
  const onSelectVariable = (ids) => {
    const interactionVariables = (ids || []).map((id) => {
      const _variableInteraction =
        currentTaskInstance?.variable_interactions.filter((el) => el.variable_id === id && el.type === mode)[0] || null

      return _variableInteraction
        ? _variableInteraction
        : {
            variable_id: id,
            type: mode,
            operation: mode === interactionModes.START ? interactionOperations.MINUS : interactionOperations.PLUS,
            value: 1 // -- The value is always 1, mode attribute gives the positive or negative sign of the operation
          }
    })

    // -- merge the two array of object of all interactionVariables with a different `type`
    Array.prototype.push.apply(
      interactionVariables,
      // currentTaskInstance?.variable_interactions.filter((el) => el.type !== mode)
      variablesSelected.filter((el) => el.type === mode)
    )

    Array.prototype.push.apply(
      interactionVariables,
      currentTaskInstance?.variable_interactions.filter((el) => el.type !== mode)
    )

    Logger.trace(LoggerTypes.CONTROLLER, 'FlowElementTaskInteractionDialog.onSelectVariable()', {
      ids,
      variablesSelected,
      // variable_interactions: variablesSelected.filter((el) => el.type === mode),
      interactionVariables
    })

    onAddInteraction(clearData(interactionVariables))
  }
  const columnsVariables = [
    {
      field: 'id',
      headerName: 'ID',
      renderCell: (e) => <DebugView type={attributesNames.VARIABLES}>{e.row}</DebugView>,
      width: 220
    },
    {
      field: 'name',
      headerName: t('attributes.variables.columns.name'),
      flex: 1,
      minWidth: 250
      // renderCell: (e) => <DataGridRowLink ref={ref} tooltip={e.row.description} text={e.formattedValue} />
    },
    {
      field: 'description',
      headerName: t('attributes.variables.columns.description'),
      flex: 1,
      minWidth: 250
    },
    {
      field: 'initial_value',
      headerName: t('attributes.variables.columns.initial_value'),
      width: 150
    },
    {
      field: 'unit',
      headerName: t('attributes.variables.columns.unit'),
      width: 100
    }
  ]
  /**
   * DEPRECATED:
   * convert: currentTaskInstance.variable_interactions = [{ id: 'xxx-UUID-xxx', operation: 'PLUS', quantity: 1 }, ...]
   * into: variablesSelected = ['xxx-UUID-xxx', ...]
   */
  // const variablesSelected = (currentTaskInstance?.variable_interactions || []).filter((el) => el.type === mode).map((el) => el.variable_id) || []

  // useEffect(() => {
  //   loadData()
  // }, [])

  Logger.trace(LoggerTypes.CONTAINER, 'FlowElementTaskInteractionDialog.render()', {
    currentProject,
    currentScenario,
    currentFlowGroup,
    // currentTaskInstance,
    openDialog,
    type,
    variables: {
      mode,
      variables,
      variablesSelected
    },
    resources: {
      resources,
      resourcesSelected
    }
  })

  return (
    openDialog && (
      <Dialog
        fullwidth={true}
        maxWidth={dialogSize.LARGE}
        open={openDialog}
        // onClose={onDialogClose} // <-- allow to close the popin while clicking on background
        aria-labelledby="form-dialog-title"
        className={'FlowElementDialog FlowElementTaskInteractionDialog'}
      >
        <DialogContent>
          <Button
            mode={buttonModes.SECONDARY_ACTION}
            type={buttonTypes.BUTTON}
            tooltip={t('common.close')}
            icon={<CloseIcon className={styleClasses.closeIconStyle} />}
            onClick={onDialogClose}
            className={`headerButton ${styleClasses.closeStyle}`}
          />
          <div className="import-tabs">
            <FormTitle
              title={
                type === attributesNames.VARIABLES
                  ? t('flowActions.tasks.panels.interactions.variables.dialog_title')
                  : t('flowActions.tasks.panels.interactions.resources.dialog_title')
              }
              icon={type === attributesNames.VARIABLES ? iconNames.VARIABLE : iconNames.RESOURCE}
              iconSize={26}
              style={{ fontSize: '20px' }}
            />

            {type === attributesNames.RESOURCES ? (
              <DataGrid
                isLoading={false}
                checkboxSelection={true}
                hideFooterPagination={false}
                disableColumnFilter={true}
                exportData={false}
                columns={columnsResources}
                columnVisibilityModel={{ id: isDebug() }}
                rows={resources}
                selectionModel={resourcesSelected}
                onSelectionModelChange={onSelectResource}
                actionsButtons={[]}
              />
            ) : (
              <DataGrid
                isLoading={false}
                checkboxSelection={true}
                hideFooterPagination={false}
                disableColumnFilter={true}
                exportData={false}
                columns={columnsVariables}
                columnVisibilityModel={{ id: isDebug() }}
                rows={variables}
                selectionModel={variablesSelected}
                onSelectionModelChange={onSelectVariable}
                actionsButtons={[]}
              />
            )}
          </div>
        </DialogContent>
      </Dialog>
    )
  )
}

FlowElementTaskInteractionDialog.displayName = 'FlowElementTaskInteractionDialog'

FlowElementTaskInteractionDialog.propTypes = {
  currentProject: PropTypes.object.isRequired,
  currentScenario: PropTypes.object,
  currentFlowGroup: PropTypes.object,
  currentTaskInstance: PropTypes.object,
  variables: PropTypes.arrayOf(PropTypes.object),
  resources: PropTypes.arrayOf(PropTypes.object),
  openDialog: PropTypes.bool.isRequired,
  setOpenDialog: PropTypes.func.isRequired,
  mode: PropTypes.oneOf(['ON_START', 'ON_FINISH', null, undefined]), // <-- Can be 'interactionModes.START' or 'interactionModes.FINISH'
  type: PropTypes.oneOf(['variables', 'resources']) // <-- Can be 'attributesNames.VARIABLES' or 'attributesNames.RESOURCES'
  // refreshAfterSaving: PropTypes.func
}

FlowElementTaskInteractionDialog.defaultProps = {
  currentProject: null,
  currentScenario: null,
  currentFlowGroup: null,
  currentTaskInstance: null,
  variables: [],
  resources: [],
  openDialog: false,
  setOpenDialog: null,
  mode: 'ON_START', // <-- Can be 'interactionModes.START' or 'interactionModes.FINISH'
  type: 'variables' // <-- Can be 'attributesNames.VARIABLES' or 'attributesNames.RESOURCES'
  // refreshAfterSaving: () => {}
}
